import {
    type ContractVariant,
    statusstripeContract,
} from 'aos-ds/src/primitives/statusstripe/statusstripe.contract'
import React from 'react'
import { View } from 'react-native'

import { twMerge } from '../../tailwind/merge'

export const STATUS_STRIPE_STATUSES = statusstripeContract.props.status.values

export type StatusStripeStatus = (typeof STATUS_STRIPE_STATUSES)[number]

export type StatusStripeProps = {
    status: StatusStripeStatus
    className?: string
    testID?: string
}

const variantFor = (status: StatusStripeStatus): ContractVariant => {
    const key = `status=${status}`
    const variant = (statusstripeContract.variants as Record<string, ContractVariant>)[key]
    if (!variant) {
        throw new Error(`StatusStripe: the Figma contract has no "${key}"`)
    }
    return variant
}

export const StatusStripe = ({ status, className, testID }: StatusStripeProps) => {
    const variant = variantFor(status)
    return (
        <View
            className={twMerge(variant.container, variant.box, className)}
            testID={testID ?? `status-stripe-${status}`}
        />
    )
}

StatusStripe.displayName = 'StatusStripe'
